import { CodeMessage, MESSAGES } from "src/app/shared/constants/message.constant";
import { isMobile } from "src/app/utils";

export const TIMER_EXPIRED = {
  interval: 1000,
  expiredmessage: {
    ...{
      time: 300,
      hideClose: true,
      fullscreen: true
    },
    ...MESSAGES[isMobile() ? CodeMessage.expiredSessionApp : CodeMessage.expiredSessionWeb]
  },
  preexpiredmessage: {
    ...{
      time: 30,
      rejectButton: 'Salir',
      hideClose: true
    },
    ...MESSAGES[CodeMessage.activeExpiredSession]
  }
}
